export default __webpack_public_path__ + "static/media/diamond-clarity-2@3x.9ab05e09.png";